const React = require("react");
const Classes = require("./styles.scss");

module.exports = class Footer extends React.Component {
    render() {
        const year = new Date().getFullYear();

        return (
            <div className={Classes.footerBar}>
                <div className={Classes.footerText}>
                    &copy; Copyright {year} Cashmerette. All Rights Reserved
                </div>
                <a
                    href="http://mybodymodel.com/privacypolicy"
                    className={Classes.footerLink}
                    target="_blank"
                >
                    Privacy Policy
                </a>
                <a
                    href="http://mybodymodel.com/termsofuse"
                    className={Classes.footerLink}
                    target="_blank"
                >
                    Terms of Use
                </a>
                <a
                    href="https://www.mybodymodel.com/faq/top-5-troubleshooting-tips-for-creating-a-body-model-that-youll-love/"
                    className={Classes.footerLink}
                    target="_blank"
                >
                    FAQ
                </a>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/Footer/index.js